<template>
    <div class="component-budget-summary" id="budget-summary">
        <el-card class="box-card">
            <div slot="header" class="text-left">
                <div class="row center-align-vert">
                    <div class="col-4 text-left">
                        <h4>Summary</h4>
                    </div>
                    <div class="col-8 text-right" >
                        <el-button v-if="noBudgetsOpen === false" @click="save" type="primary" :disabled="saveButtonDisabled" plain>Save budget</el-button>
                        <el-button v-else class="ml-5-howrly" type="primary" disabled plain icon="el-icon-lock">Locked</el-button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-left mt-50 mb-50">
                    <el-steps :active=progress>
                        <el-step title="Initial budget" :description="$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Predicted + ' hours'"></el-step>
                        <el-step title="Commercial changes" :description="commercialChanges"></el-step>
                        <el-step title="Store changes" :description="manualChanges"></el-step>
                        <el-step title="Final budget" :description="$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Adjusted + ' hours'"></el-step>
                    </el-steps>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { serialize } from '../../functions'

export default {
    props: ['saveButtonDisabled', 'progress'],
    data () {
        return {
            commercialChange: 0,
            noBudgetsOpen: false
        }
    },
    components: {
    },
    computed: {
        commercialChanges () {
            var hourChange = 0
            for (let p of this.$store.state.budget.prediction) {
                let b = this.$store.state.budget.budget.find(x => x.store_id === p.store_id)
                if (b !== undefined) {
                    let regressionParameters = b['regression_settings']
                    for (let param of regressionParameters) {
                        if (Object.keys(p.dataload).includes(param.var)) {
                            hourChange += (param.factor * Math.pow(p.dataload[param.var], param.transform)) - (param.factor * Math.pow(p.dataload_last_level[param.var], param.transform))
                        }
                    }
                }
            }

            let val = hourChange.toFixed()
            this.setCommercialChange(val)
            if (val > 0) {
                return '+' + this.commercialChange + ' hours'
            } else {
                return this.commercialChange + ' hours'
            }
        },
        manualChanges () {
            let val = (this.$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Adjusted - this.$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Predicted) - this.commercialChange
            if (val > 0) {
                return '+' + String(val) + ' hours'
            } else {
                return String(val) + ' hours'
            }
        }
    },
    methods: {
        setCommercialChange (val) {
            this.commercialChange = val
        },
        save () {
            let promiseList = [this.$store.dispatch('budget/saveBudget', { 'route': serialize(this.$route.query) + '&org_id=' + localStorage.getItem('org_id') }), this.$store.dispatch('budget/savePrediction', { 'route': serialize(this.$route.query) + '&org_id=' + localStorage.getItem('org_id') })]
            Promise.all(promiseList).then(response => {
                this.$router.push({ name: 'budget-tasks', params: { } })
            })
                .catch(error => {
                    console.log(error)
                })
        },
        budgetOpen () {
            // If there is any underlying budget that is open, you can change this
            for (let b of this.$store.state.budget.budget) {
                if (b.budget_open === true) {
                    return true
                }
            }
            return false
        }
    },
    mounted () {
        if (this.budgetOpen() === false) {
            this.noBudgetsOpen = true
        }
    }
}
</script>

<style lang="scss">
.component-budget-summary {
    .el-button {
        margin-left: 5px;
    }
}
</style>
